(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

// Create Cookie for 5 seconds
function createCookie(name, value) {
  var date = new Date();
  date.setTime(date.getTime() + 5 * 1000);
  var expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + value + expires + "; path=/";
} // Get Cookie by name


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

jQuery(document).ready(function ($) {
  //setup before functions
  var typingTimer; //timer identifier

  var doneTypingInterval = 5000; //time in ms, 5 second for example

  var $input = $('#rtb-phone, #billing_phone'); //on keyup, start the countdown

  $input.on('keyup', function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  }); //on keydown, clear the countdown 

  $input.on('keydown', function () {
    clearTimeout(typingTimer);
  }); //user is "finished typing," do something

  function doneTyping() {
    //console.log( $input.val().length );
    if ($input.val().length < 9 || $input.val().length > 15) {
      if (typeof invalid_number_message !== 'undefined') {
        alert(invalid_number_message);
      } else {
        alert('Please, insert a valid number.');
      }

      return false;
    }
  }

  jQuery('.rtb-booking-form-form button').on('click', function (event) {
    var result = doneTyping();

    if (result === false) {
      event.preventDefault();
    }
  });
  jQuery('.product__action .add_to_cart_button').on('click', function () {
    $(this).click(false);
  });
  jQuery("#delivery_hour_on_field.old-checkout").on('change', function () {
    var curentValue = jQuery('input[name=delivery_hour_on]:checked').val();

    if (curentValue == 'choose_date') {
      jQuery('#delivery_time_field').css('display', 'block');
      jQuery('#delivery_hour_field').css('display', 'block');
    } else {
      jQuery('#delivery_time_field').css('display', 'none');
      jQuery('#delivery_hour_field').css('display', 'none');
    }
  });
  jQuery('.add_to_cart_button').on('click', function () {
    setTimeout(function () {
      jQuery('.sidebar-toggle').click();
    }, 1000);
  });
  jQuery("#rtb-phone, #billing_phone").keypress(function (evt) {
    var charCode = evt.which ? evt.which : event.keyCode;

    if (charCode != 43 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  });
  $('.single_add_to_cart_button').on('click', function () {
    //$(this).css('display', 'none');
    //$('.sk-circle').css('visibility', 'visible');
    createCookie('open', 'true');
  });

  if (getCookie('open') == 'true') {
    $('.sidebar-toggle').click();
  }

  $(document).on('click', '.plus', function (e) {
    var input = $(this).prev('input.qty');
    var val = parseInt(input.val());
    var step = input.attr('step');
    step = 'undefined' !== typeof step ? parseInt(step) : 1;
    input.val(val + step).change();
    $("[name='update_cart']").trigger("click");
  });
  $(document).on('click', '.minus', function (e) {
    var input = $(this).next('input.qty');
    var val = parseInt(input.val());
    var step = input.attr('step');
    step = 'undefined' !== typeof step ? parseInt(step) : 1;

    if (val > 1) {
      input.val(val - step).change();
      $("[name='update_cart']").trigger("click");
    }
  });
  jQuery(document).on('click', '.btnMinus, .btnPlus', function () {
    jQuery(this).parent().siblings('.overlay').addClass("show-element");
  });
  jQuery('.contactSection .koo-icon-box--left-icon a').attr('target', '_blank');
  jQuery('.woocommerce-form-register, .woocommerce-checkout').on('submit', function () {
    var emailValue = jQuery('#reg_email').val();

    if (emailValue != "") {
      jQuery('#reg_username').val(emailValue);
    }
  });
  jQuery('#billing_email').keyup(function () {
    var emailValueCheckout = jQuery(this).val();

    if (emailValueCheckout != "") {
      jQuery('#account_username').val(emailValueCheckout);
    }
  });
  setTimeout(function () {
    if ($('#terms_and_conditions').length > 0) {
      $('#terms_and_conditions').trigger('click');
    }

    if ($('#gdpr').length > 0) {
      $('#gdpr').trigger('click');
    }

    if ($('#gdpr_email').length > 0) {
      $('#gdpr_email').trigger('click');
    }

    if ($('#gdpr_sms').length > 0) {
      $('#gdpr_sms').trigger('click');
    }
  }, 300);
  jQuery("select[name='delivery_method']").on('change', function () {
    if (this.value == "livrare-la-domiciliu") {
      jQuery('#billing_address_1_field').show();
      jQuery('#billing_city_field').show();
      jQuery('#areas').show();
    } else {
      jQuery('#billing_address_1_field').hide();
      jQuery('#billing_city_field').hide();
      jQuery('#areas').hide();
    }
  });
  jQuery('#delivery_method .blue-cards label').on('click', function () {
    if (jQuery(this).find('input').val() == "livrare-la-domiciliu") {
      jQuery('#billing_address_1_field').show();
      jQuery('#billing_city_field').show();
      jQuery('#areas').show();
      jQuery('#billing_bloc_field').show();
      jQuery('#billing_apartament_field').show();
      jQuery('#billing_scara_field').show();
      jQuery('#billing_etaj_field').show(); // hide

      jQuery('#pickup_point_field').hide();
    } else {
      jQuery('#billing_address_1_field').hide();
      jQuery('#billing_city_field').hide();
      jQuery('#areas').hide();
      jQuery('#billing_bloc_field').hide();
      jQuery('#billing_apartament_field').hide();
      jQuery('#billing_scara_field').hide();
      jQuery('#billing_etaj_field').hide();

      if (jQuery(this).find('input').val() == 'ridicare-personala') {
        jQuery('#pickup_point_field').show();
      } else {
        jQuery('#pickup_point_field').hide();
      }
    }
  });
  $(document).on("click", ".back-to-shopping a", function () {
    $('.mini-cart-header').toggleClass('active');
    $('body').toggleClass('mini-cart-active');
  });
});

},{}]},{},[1]);
